import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { projects } from '../data/content';
import { Reveal } from './Reveal';
export function Projects() {
  return <section id="proyectos" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-24 lg:px-10 lg:py-32" data-id="element-103" data-mp="fty3qz66wlyn">
      <Reveal className="max-w-2xl" data-id="element-104" data-mp="umi0ni2qxx7n">
        <p className="text-[13px] font-medium uppercase tracking-[0.16em] text-accent" data-id="element-105" data-mp="ptp1ratylj3h">Proyectos</p>
        <h2 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink lg:text-5xl" data-id="element-106" data-mp="13kk8ohkwdq4f">
          Trabajo reciente
        </h2>
      </Reveal>

      <ul className="mt-12 divide-y divide-slate-200 border-y border-slate-200" data-id="element-107" data-mp="1djj9jdzf8hgv">
        {projects.map((project, i) => <li key={project.title} data-id="element-108" data-mp="18jwzteisxjct" data-mpi={i}>
            <Reveal delay={i * 0.06} data-id="element-109" data-mp="18kzl96xcutlc">
              <a href="#contacto" className="group flex flex-col gap-3 py-7 transition-colors duration-300 hover:bg-white/70 sm:flex-row sm:items-center sm:justify-between sm:gap-8 sm:px-4" data-id="element-110" data-mp="3fawf8597qtdz">
                <div className="min-w-0" data-id="element-111" data-mp="1xd2atu1vwmo0">
                  <p className="text-[13px] font-medium uppercase tracking-[0.14em] text-slate-500" data-id="element-112" data-mp="1x9y3int4hat4">
                    {project.client} · {project.tag}
                  </p>
                  <h3 className="mt-2 text-xl font-semibold tracking-[-0.02em] text-ink transition-colors group-hover:text-accent lg:text-2xl" data-id="element-113" data-mp="26b6091fzq3l3">
                    {project.title}
                  </h3>
                </div>
                <div className="flex items-center gap-5" data-id="element-114" data-mp="2g4v5ru0ikhyd">
                  <span className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-ink-soft" data-id="element-115" data-mp="2l0ahafb1u1rm">
                    {project.metric}
                  </span>
                  <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-slate-300 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-accent" aria-hidden="true" data-id="element-116" data-mp="2u18nn48ymldd" />
                </div>
              </a>
            </Reveal>
          </li>)}
      </ul>
    </section>;
}